import React from 'react'
import {
  Box,
  Typography
} from '@mui/material'
import { HasProduct } from '@/modules/product/types/product'
import { CartItem } from '@/modules/cart/types/cart'
import {
  findOption,
  getPrice
} from '@/modules/product/utils'

export const ProductPrice = ({ product, option, sx }: { sx?: any } & CartItem & HasProduct) => {
  const { formatted } = getPrice({
    option: findOption({ product, id: option?.id })
  })

  const isTaxable = option.price > 0

  return (
    <Box
      data-cy={`product_price_${product.sku}`}
      sx={sx}
      display={'flex'}
      flexDirection={'column'}
      alignItems={'center'}>

      <Typography variant={'h6'}>
        {formatted}
      </Typography>
      {isTaxable &&
        <Typography variant={'body2'}>+ Tax</Typography>
      }

    </Box>
  )
}